import { render, staticRenderFns } from "./CollectionPoint.vue?vue&type=template&id=ad5a6c0a"
import script from "./CollectionPoint.vue?vue&type=script&lang=js"
export * from "./CollectionPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports